/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createFavoriteListFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeFavoriteList, serializeRemoveItemFromListRequest, type ErrorResponse, type FavoriteList, type InternalErrorResponse, type RemoveItemFromListRequest } from '../../../../../../models/index.js';
// @ts-ignore
import { QuantityRequestBuilderRequestsMetadata, type QuantityRequestBuilder } from './quantity/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/favorites/{customerNumber-id}/{favoriteListId}/items/{sku}
 */
export interface WithSkuItemRequestBuilder extends BaseRequestBuilder<WithSkuItemRequestBuilder> {
    /**
     * The quantity property
     */
    get quantity(): QuantityRequestBuilder;
    /**
     * Drops one SKU from the list and returns the whole list back. The removal is outright — the line is gone rather than zeroed, and nothing about the product itself is affected. The SKU is matched without regard to case and must be on the list: removing one that is already absent is a 400 rather than a silent success, so this call is not idempotent. The 404 is reserved for the list itself.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FavoriteList>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(body: RemoveItemFromListRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FavoriteList | undefined>;
    /**
     * Drops one SKU from the list and returns the whole list back. The removal is outright — the line is gone rather than zeroed, and nothing about the product itself is affected. The SKU is matched without regard to case and must be on the list: removing one that is already absent is a 400 rather than a silent success, so this call is not idempotent. The 404 is reserved for the list itself.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(body: RemoveItemFromListRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithSkuItemRequestBuilderUriTemplate = "{+baseurl}/api/favorites/{customerNumber%2Did}/{favoriteListId}/items/{sku}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithSkuItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithSkuItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    quantity: {
        requestsMetadata: QuantityRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithSkuItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithSkuItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFavoriteListFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeRemoveItemFromListRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
